<button mat-raised-button
        class="save-btn"
        [disabled]="isSaving || disabled()"
        (click)="saveElement()"
        [@buttonState]="animationState">
  <span>{{ buttonLabel }}</span>
  @if (animationState === 'saving') {
    <mat-icon class="loading-icon">autorenew</mat-icon>
  }
  @if (animationState === 'idle') {
    <mat-icon>save</mat-icon>
  }
  @if (animationState === 'saved') {
    <mat-icon>check_circle</mat-icon>
  }
</button>
